/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_UnknownInputs */

const en_customer_unknown = /** @type {(inputs: Customer_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name on its way`)
};

/**
* | output |
* | --- |
* | "Name on its way" |
*
* @param {Customer_UnknownInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const customer_unknown = /** @type {((inputs?: Customer_UnknownInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_UnknownInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_customer_unknown(inputs)
});